<template>
  <div class="profile-settings">
    <label for="timezone">Timezone</label>
    <ElementSelect
      v-model="timezone"
      placeholder="Select a timezone"
      filterable
      class="timezone-select"
    >
      <ElementOption
        v-for="tz in TIMEZONES"
        :key="tz.id"
        :label="tz.label"
        :value="tz.value"
      />
    </ElementSelect>
    <ElementButton
      class="settings--button-current-timezone"
      @click="setCurrentTimezone"
    >
      Set to Current Timezone
    </ElementButton>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { TIMEZONES } from '@/constants/timezones'

export default {
  name: 'ProfileSettings',

  data () {
    return {
      TIMEZONES
    }
  },

  computed: {
    ...mapGetters({
      profileTimezone: 'getProfileTimezone',
      user: 'getCognitoUserData'
    }),

    /**
     * Computed property for timezone with logging.
     */
    timezone: {
      /**
       * Retrieve the current profile timezone from the store.
       *
       * @returns {string}
       */
      get () {
        return this.profileTimezone
      },

      /**
       * Update the profile timezone in the backend and store.
       *
       * @param   {string} value - The new timezone value.
       * @returns {void}
       */
      set (value) {
        this.updateProfileSettings({ timezone: value })

        this.$message({
          showClose: true,
          message: `Timezone ${value} has been successfully set`,
          duration: 4000
        })
      }
    }
  },

  mounted () {
    this.fetchProfileSettings()
  },

  methods: {
    ...mapActions(['fetchProfileSettings', 'updateProfileSettings']),

    /**
     * Sets the timezone to the user's current system timezone,
     * if it's present in the list of available timezones.
     *
     * @returns {void}
     */
    setCurrentTimezone () {
      this.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
    }
  }
}
</script>

<style lang="scss" scoped>
$color-text-default: #333;
$color-surface: #fff;
$color-border-default: #edebeb;
$font-size-sm: 14px;
$font-size-m: 16px;
$border-radius-sm: 8px;
$label-min-width: 120px;
$timezone-select-width: 500px;

.profile-settings {
  display: flex;
  gap: spacing(1);
  align-items: center;
  margin-bottom: spacing(6);
  margin-left: spacing(1.5);
  padding: spacing(4);
  color: $color-text-default;
  font-size: $font-size-sm;
  font-family: arial, sans-serif;
  background-color: $color-surface;
  border: 1px solid $color-border-default;
  border-radius: $border-radius-sm;
}

label {
  min-width: $label-min-width;
  margin-bottom: 0;
  font-weight: $font-weight-medium;
  font-size: $font-size-m;
}

.timezone-select {
  width: $timezone-select-width;
}
</style>
